<mat-card *ngIf="!updateMode">
    {{'addProduct' | translate}}
</mat-card>

<mat-card *ngIf="updateMode">
    {{'updateProduct' | translate}}
</mat-card>

<div align="end" class="row" style="padding:10px 10px 0 0;">
    <span class="spacer"></span>

    <button mat-raised-button color="primary" (click)="submit()" *ngIf="!_submit"
        [disabled]="ProductForm.invalid && !updateMode">
        <mat-icon>done</mat-icon>
        {{'submit' | translate}}
    </button>
    &nbsp;
    <button mat-raised-button color="primary" (click)="addNew()" *ngIf="_submit">
        <mat-icon>add</mat-icon>
        {{'addNew' | translate}}
    </button>
    &nbsp;
    <button mat-raised-button color="primary" (click)="downloadTemp()" *ngIf="!_submit">
        <mat-icon>arrow_downward</mat-icon>
        {{'downloadTemplate' | translate}}
    </button>
    &nbsp;
    <button mat-raised-button color="primary" (click)="Import()" *ngIf="!_submit">
        <mat-icon>import_export</mat-icon>
        {{'import' | translate}}
    </button>
    &nbsp;
    <button mat-raised-button color="primary" (click)="viewDropify()" *ngIf="!_submit">
        <mat-icon *ngIf="!viewImage">add_a_photo</mat-icon>
        <mat-icon *ngIf="viewImage">hide_image</mat-icon>
        <span *ngIf="!viewImage">&nbsp; {{'addImage' | translate}}</span>
        <span *ngIf="viewImage">&nbsp; {{'hideImage' | translate}}</span>
        <!-- {{!viewImage ? 'addImage' | translate : 'hideImage' | translate}} -->
    </button>
    &nbsp;
    <!-- <button mat-raised-button color="primary" (click)="onShowSoled()" *ngIf="!_submit && updateMode">
        <mat-icon *ngIf="!showSoled">visibility</mat-icon>
        <mat-icon *ngIf="showSoled">visibility_off</mat-icon>
        <span *ngIf="!showSoled">&nbsp; {{'showSoled' | translate}}</span>
        <span *ngIf="showSoled">&nbsp; {{'hideSoled' | translate}}</span>
    </button> -->

    <button mat-raised-button color="primary" (click)="exportCardsToExcel()">
        <mat-icon *ngIf="!viewImage">import_export</mat-icon>
        تصدير البطاقات
    </button>
    &nbsp;
    <button mat-raised-button (click)="back()">
        <mat-icon>keyboard_backspace</mat-icon>
        {{'back' | translate}}
    </button>
    &nbsp;
</div>


<br />
<mat-grid-list cols="3" rowHeight="200px" id="dropifyImage" style="display: none;">
    <mat-grid-tile>
        <!-- <mat-label>Image</mat-label> -->
        <input type="file" id="image1" class="dropify" (change)="onSelectImage($event)" />
    </mat-grid-tile>

    <mat-grid-tile [ngStyle]="accessories ? {'visibility': 'visible'} : {'visibility': 'hidden'}">
        <!-- <mat-label>Image</mat-label> -->
        <input type="file" id="image2" class="dropify" (change)="onSelectImage2($event)" />
    </mat-grid-tile>

    <mat-grid-tile [ngStyle]="accessories ? {'visibility': 'visible'} : {'visibility': 'hidden'}">
        <!-- <mat-label>Image</mat-label> -->
        <input type="file" id="image3" class="dropify" (change)="onSelectImage3($event)" />
    </mat-grid-tile>

</mat-grid-list>

<form [formGroup]="ProductForm" #formDir="ngForm">
    <br>
    <mat-grid-list cols="5" rowHeight="70px">


        <mat-grid-tile colspan="1">
            <mat-form-field appearance="standard" style="margin-right: 5px;">
                <mat-label>{{'directCharged' | translate}}</mat-label>
                <mat-select formControlName="direct" (selectionChange)="onDirectChargedChanged()"
                    [disabled]="product.bytic == 1">
                    <mat-option [value]="true"> {{'yes' | translate}} </mat-option>
                    <mat-option [value]="false"> {{'no' | translate}} </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

        <!-- <mat-grid-tile> 
            
            <mat-checkbox class="example-margin" formControlName="direct" (change)="onDirectChargedChanged()">{{'directCharged' | translate}}</mat-checkbox>
        </mat-grid-tile> -->

        <mat-grid-tile>

            <mat-form-field appearance="standard" class="example-full-width" style="margin-left: 3px;">
                <mat-label> {{'selectCategory' | translate}}</mat-label>
                <input type="text" matInput formControlName="category" required [matAutocomplete]="auto">
                <button mat-button matSuffix mat-icon-button>
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </button>
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectCatChange($event.option.value)"
                    [displayWith]="displayFnCategory">
                    <mat-option *ngFor="let option of filteredOptionsCategory | async" [value]="option">
                        <img class="example-option-img" aria-hidden
                            [src]="option.pytic != 1 ? imagPath + option.imageUrl : option.imageUrl" height="25"
                            width="25" style="object-fit: fill;">
                        <span>&nbsp;</span>
                        <span>{{lang == 1 ? option.arabicName : option.englishName}}</span>
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="ProductForm.controls.category.invalid">{{'requiredField' | translate}}</mat-error>
            </mat-form-field>
            <span>&nbsp;</span>

        </mat-grid-tile>

        <mat-grid-tile>

            <mat-form-field appearance="standard" class="example-full-width" style="margin-left: 3px;">
                <mat-label> {{'selectSubCategory' | translate}}</mat-label>
                <input type="text" matInput formControlName="subCategory" required [matAutocomplete]="auto1">
                <button mat-button matSuffix mat-icon-button>
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </button>
                <mat-autocomplete #auto1="matAutocomplete" [displayWith]="displayFnSubCategory">
                    <mat-option *ngFor="let option of filteredOptionsSubCategory | async" [value]="option">
                        <img class="example-option-img" aria-hidden
                            [src]="option.bytic != 1 ? imagPath + option.imgUrl : option.imgUrl" height="25" width="25"
                            style="object-fit: fill;">
                        <span>&nbsp;</span>
                        <span>{{lang == 1 ? option.arabicName : option.englishName}}</span>
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="ProductForm.controls.subCategoryId.invalid">{{'requiredField' | translate}}
                </mat-error>
            </mat-form-field>
            <span>&nbsp;</span>

        </mat-grid-tile>

        <mat-grid-tile>
            <mat-form-field appearance="standard" class="example-full-width">
                <mat-label>{{'arabicName' | translate}}</mat-label>
                <input matInput formControlName="arabicName">
                <mat-error *ngIf="ProductForm.controls.arabicName.invalid">{{'requiredField' | translate}}</mat-error>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
            <mat-form-field appearance="standard" class="example-full-width">
                <mat-label>{{'englishName' | translate}}</mat-label>
                <input matInput formControlName="englishName">
                <mat-error *ngIf="ProductForm.controls.englishName.invalid">{{'requiredField' | translate}}</mat-error>
            </mat-form-field>
        </mat-grid-tile>





    </mat-grid-list>
    <br />
    <mat-grid-list cols="5" rowHeight="70px">

        <mat-grid-tile>
            <mat-form-field appearance="standard">
                <mat-label>{{'category1Price' | translate}}</mat-label>
                <input matInput formControlName="price1" type="number">
                <span matPrefix>JOD&nbsp;</span>
                <mat-error *ngIf="ProductForm.controls.price1.invalid">{{'requiredField' | translate}}</mat-error>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
            <mat-form-field appearance="standard">
                <mat-label>{{'category2Price' | translate}}</mat-label>
                <input matInput formControlName="price2" type="number">
                <span matPrefix>JOD&nbsp;</span>
                <mat-error *ngIf="ProductForm.controls.price2.invalid">{{'requiredField' | translate}}</mat-error>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
            <mat-form-field appearance="standard">
                <mat-label>{{'category3Price' | translate}}</mat-label>
                <input matInput formControlName="price3" type="number">
                <span matPrefix>JOD&nbsp;</span>
                <mat-error *ngIf="ProductForm.controls.price3.invalid">{{'requiredField' | translate}}</mat-error>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
            <mat-form-field appearance="standard">
                <mat-label>{{'category4Price' | translate}}</mat-label>
                <input matInput formControlName="price4" type="number">
                <span matPrefix>JOD&nbsp;</span>
                <mat-error *ngIf="ProductForm.controls.price4.invalid">{{'requiredField' | translate}}</mat-error>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
            <mat-form-field appearance="standard">
                <mat-label>{{'category5Price' | translate}}</mat-label>
                <input matInput formControlName="price5" type="number">
                <span matPrefix>JOD&nbsp;</span>
                <mat-error *ngIf="ProductForm.controls.price5.invalid">{{'requiredField' | translate}}</mat-error>
            </mat-form-field>
        </mat-grid-tile>

    </mat-grid-list>

    <br />

    <mat-grid-list cols="5" rowHeight="70px">

        <mat-grid-tile>
            <mat-form-field appearance="standard">
                <mat-label>{{'category6Price' | translate}}</mat-label>
                <input matInput formControlName="price6" type="number">
                <span matPrefix>JOD&nbsp;</span>
                <mat-error *ngIf="ProductForm.controls.price6.invalid">{{'requiredField' | translate}}</mat-error>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
            <mat-form-field appearance="standard">
                <mat-label>{{'category7Price' | translate}}</mat-label>
                <input matInput formControlName="price7" type="number">
                <span matPrefix>JOD&nbsp;</span>
                <mat-error *ngIf="ProductForm.controls.price7.invalid">{{'requiredField' | translate}}</mat-error>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
            <mat-form-field appearance="standard">
                <mat-label>{{'category8Price' | translate}}</mat-label>
                <input matInput formControlName="price8" type="number">
                <span matPrefix>JOD&nbsp;</span>
                <mat-error *ngIf="ProductForm.controls.price8.invalid">{{'requiredField' | translate}}</mat-error>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
            <mat-form-field appearance="standard">
                <mat-label>{{'category9Price' | translate}}</mat-label>
                <input matInput formControlName="price9" type="number">
                <span matPrefix>JOD&nbsp;</span>
                <mat-error *ngIf="ProductForm.controls.price9.invalid">{{'requiredField' | translate}}</mat-error>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
            <mat-form-field appearance="standard">
                <mat-label>{{'category10Price' | translate}}</mat-label>
                <input matInput formControlName="price10" type="number">
                <span matPrefix>JOD&nbsp;</span>
                <mat-error *ngIf="ProductForm.controls.price10.invalid">{{'requiredField' | translate}}</mat-error>
            </mat-form-field>
        </mat-grid-tile>

    </mat-grid-list>

    <mat-grid-list cols="5" rowHeight="70px">

        <mat-grid-tile>
            <mat-form-field appearance="standard">
                <mat-label>{{'costPrice' | translate}}</mat-label>
                <input matInput formControlName="costPrice" type="number">
                <mat-error *ngIf="ProductForm.controls.costPrice.invalid">{{'requiredField' | translate}}</mat-error>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
            <mat-form-field appearance="standard">
                <mat-label>{{'purchaseLimit' | translate}}</mat-label>
                <input matInput formControlName="purchaseLimit" type="number">
                <!-- <mat-error *ngIf="ProductForm.controls.price5.invalid">{{'requiredField' | translate}}</mat-error> -->
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
            <mat-form-field appearance="standard">
                <mat-label>{{'dailyPurchaseLimit' | translate}}</mat-label>
                <input matInput formControlName="dailyPurchaseLimit" type="number">
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
            <mat-checkbox *ngIf="updateMode" class="example-margin" formControlName="statusBool">{{'active' |
                translate}}
            </mat-checkbox>
        </mat-grid-tile>



    </mat-grid-list>

    <br>
    <mat-grid-list cols="5" *ngIf="!ProductForm.value.direct && accessories == false">

        <!-- <mat-grid-tile colspan="4">  -->
        <mat-form-field class="example-chip-list" appearance="fill">
            <mat-label>{{'addCardsNo' | translate}}</mat-label>
            <mat-chip-list #chipList aria-label="Fruit selection">
                <mat-chip *ngFor="let fruit of productsListNo" [selectable]="selectable" [removable]="removable"
                    (removed)="remove(fruit)">
                    {{fruit}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                </mat-chip>
                <input [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="add($event)">
            </mat-chip-list>
        </mat-form-field>

        <!-- </mat-grid-tile> -->

        <!-- <mat-grid-tile> -->

        &nbsp;
        <button mat-raised-button color="primary" (click)="addCardsToList()" [disabled]="productsListNo.length == 0">
            <mat-icon>done</mat-icon>
            {{'add' | translate}}
        </button>
        &nbsp;
        <button mat-raised-button color="primary" (click)="clearCardsNo()" [disabled]="productsListNo.length == 0">
            <mat-icon>delete_outline</mat-icon>
            {{'clear' | translate}}
        </button>

        <!-- </mat-grid-tile> -->

    </mat-grid-list>


    <div formArrayName="productCards" *ngIf="!ProductForm.value.direct && accessories == false">
        <div *ngFor="let item of getProductCardControls();let i = index" [formGroupName]="i">
            <mat-grid-list cols="4" rowHeight="70px"
                *ngIf="item.value.status == 0 || (item.value.status == 1 && showSoled)">

                <mat-grid-tile>
                    <mat-form-field appearance="standard">
                        <mat-label>{{'cardNo' | translate}}</mat-label>
                        <input matInput formControlName="cardNumber">
                        <!-- <mat-error *ngIf="ProductForm.controls.price.invalid">Price is required</mat-error> -->
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile>
                    <mat-form-field appearance="standard">
                        <mat-label>{{'serialNo' | translate}}</mat-label>
                        <input matInput formControlName="serialNumber">
                        <!-- <mat-error *ngIf="ProductForm.controls.price.invalid">Price is required</mat-error> -->
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile>
                    <mat-form-field appearance="standard">
                        <mat-label>{{'expiry' | translate}}</mat-label>
                        <input matInput formControlName="expiryDate" [matDatepicker]="picker">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        <!-- <mat-error *ngIf="ProductForm.controls.price.invalid">Price is required</mat-error> -->
                    </mat-form-field>


                </mat-grid-tile>

                <mat-grid-tile>
                    <!-- <button mat-raised-button color="accent" >
                    <mat-icon>add</mat-icon>
                    Add new
                </button> -->

                    <button type="button" *ngIf="i == getProductCardControls().length -1" mat-icon-button
                        aria-label="Example icon button with a vertical three dot icon" (click)="addProductCardRow()">
                        <mat-icon>add</mat-icon>
                    </button>

                    <button type="button" *ngIf="getProductCardControls().length > 1" mat-icon-button
                        aria-label="Example icon button with a vertical three dot icon"
                        (click)="deleteProductCardRow(i)">
                        <mat-icon>delete</mat-icon>
                    </button>

                </mat-grid-tile>

            </mat-grid-list>

        </div>
    </div>

    <input id="file-input" type="file" name="name" style="display: none;" (change)="importCards($event)"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />

</form>

<ng-template #Modal>

    <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
    <div mat-dialog-content>
        <p>{{'areYouSureToDelete' | translate}}</p>

    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
        <button mat-button cdkFocusInitial (click)="confirmDelete()">{{'yes' | translate}}</button>
    </div>

</ng-template>


<app-matspinner [overlay]="spinnerOverlay"></app-matspinner>